export default function initToggleCentraDisplay(el) {
    const map = document.querySelector("[data-display='map']");
    const fiches = document.querySelector("[data-display='fiches']");

    el.addEventListener("change", () => {
        const isChecked = el.checked;
        fiches.classList.toggle("hide", isChecked);
        map.classList.toggle("hide", !isChecked);

        const url = new URL(window.location.href);
        url.searchParams.set("map", isChecked);
        history.replaceState(null, '', url.toString());
    });
}